import {
  type DependencyList,
  type EffectCallback,
  useEffect,
  useRef,
} from 'react';

/**
 * Like `useEffect`, but skips the initial render.
 *
 * Runs the effect only when dependencies *change* — not when they first appear
 * on mount. Useful for syncing internal state with a prop without triggering
 * a redundant effect on the initial render.
 */
export function useEffectOnChange(
  effect: EffectCallback,
  deps: DependencyList
): void {
  const isInitialRender = useRef(true);

  useEffect(() => {
    if (isInitialRender.current) {
      isInitialRender.current = false;
      return;
    }
    return effect();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, deps);
}
